<template>
  <h5 class="fw-light mb-2">Itens Medidos:</h5>
  <div class="table-responsive">
    <table class="table table-xs table-striped fs-sm">
      <thead>
        <tr>
          <th>Centro de Custo</th>
          <th>Item</th>
          <th class="text-center">Nº Sequencial</th>
          <th class="text-center">Quantidade</th>
          <th class="text-center">Valor Unitário</th>
          <th class="text-center">Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.costCenter }}</td>
          <td>{{ item.itemName }}</td>
          <td class="text-center">{{ item.sequentialNumber }}</td>
          <td class="text-center">{{ item.amount }}</td>
          <td class="text-center">{{ formatToCurrencyBr(item.price) }}</td>
          <td class="text-center">{{ formatToCurrencyBr(item.totalValue) }}</td>
        </tr>
        <tr>
          <td colspan="5"><strong>Total</strong></td>
          <td class="text-center">{{ formatToCurrencyBr(totalValue) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { formatToCurrencyBr } from '@/utils/currency'

export default {
  name: 'ItemsMeasure',

  props: {
    items: {
      type: Array,
      required: true,
    },
    totalValue: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      formatToCurrencyBr,
    }
  },
}
</script>
